<!--
  @project E-School Web
  @author Vothana CHY
  @date 2026-06-30
-->

<template>
  <div>
    <slot />
    <ScrollToTop />
  </div>
</template>
